import "./styles/main.css";
import "./styles/combat-hud.css";
import "./styles/run-summary.css";

import { installBuildProvenance } from "./build-info";
import { ZoneVelocityScene } from "./render/game-scene";

installBuildProvenance();

const canvas = document.querySelector<HTMLCanvasElement>("#game");
const shell = document.querySelector<HTMLElement>("#game-shell");
const combatHud = document.querySelector<HTMLElement>("#combat-hud");
const status = document.querySelector<HTMLElement>("#status");
const vitals = document.querySelector<HTMLElement>("#vitals");
const affixChips = document.querySelector<HTMLElement>("#affix-chips");
const loadoutRail = document.querySelector<HTMLElement>("#loadout-rail");
const runChips = document.querySelector<HTMLElement>("#run-chips");
const softLockReticle = document.querySelector<HTMLElement>("#soft-lock-reticle");
const outcomeBeat = document.querySelector<HTMLElement>("#outcome-beat");
const inventory = document.querySelector<HTMLElement>("#inventory");
const band = document.querySelector<HTMLElement>("#band");
const help = document.querySelector<HTMLElement>("#help");
const message = document.querySelector<HTMLElement>("#message");
const levelBadge = document.querySelector<HTMLElement>("#level-badge");
const xpBar = document.querySelector<HTMLElement>("#xp-bar");
const xpLabel = document.querySelector<HTMLElement>("#xp-label");
const score = document.querySelector<HTMLElement>("#score");
const comboMeter = document.querySelector<HTMLElement>("#combo-meter");
const comboTag = document.querySelector<HTMLElement>("#combo-tag");
const scoreFeed = document.querySelector<HTMLElement>("#score-feed");
const streak = document.querySelector<HTMLElement>("#streak");
const jammer = document.querySelector<HTMLElement>("#jammer-indicator");
const incursion = document.querySelector<HTMLElement>("#incursion-banner");
const hitVignette = document.querySelector<HTMLElement>("#hit-vignette");
const carrierNav = document.querySelector<HTMLElement>("#carrier-nav");

if (
  !canvas ||
  !shell ||
  !combatHud ||
  !status ||
  !vitals ||
  !affixChips ||
  !loadoutRail ||
  !runChips ||
  !softLockReticle ||
  !outcomeBeat ||
  !inventory ||
  !band ||
  !help ||
  !message ||
  !levelBadge ||
  !xpBar ||
  !xpLabel ||
  !score ||
  !comboMeter ||
  !comboTag ||
  !scoreFeed ||
  !streak ||
  !jammer ||
  !incursion ||
  !hitVignette ||
  !carrierNav
) {
  throw new Error("Game shell is incomplete");
}

const game = new ZoneVelocityScene({
  canvas,
  shell,
  combatHud,
  status,
  vitals,
  affixChips,
  loadoutRail,
  runChips,
  softLockReticle,
  outcomeBeat,
  inventory,
  band,
  help,
  message,
  levelBadge,
  xpBar,
  xpLabel,
  score,
  comboMeter,
  comboTag,
  scoreFeed,
  streak,
  jammer,
  incursion,
  hitVignette,
  carrierNav,
});

const onResize = (): void => {
  // Shell owns layout; canvas is position:absolute and may report 0 before paint.
  const { width, height } = shell.getBoundingClientRect();
  game.resize(width, height);
};

window.addEventListener("resize", onResize);
const resizeObserver =
  typeof ResizeObserver !== "undefined" ? new ResizeObserver(() => onResize()) : null;
resizeObserver?.observe(shell);
game.start();
onResize();
window.addEventListener(
  "beforeunload",
  () => {
    window.removeEventListener("resize", onResize);
    resizeObserver?.disconnect();
    game.dispose();
  },
  { once: true },
);
